import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import create from './create/create.js'
import textarea from './textarea/textarea.js'
import remove from './remove/remove.js'
import changeColor from './changeColor/changeColor.js'
import dragged from './dragged/dragged.js'

export default contract({
  create: array([
    create
  ]),
  remove: array([
      remove
  ]),
  textarea: array([
      textarea
  ]),
  changeColor: array([
      changeColor
  ]),
  dragged : array([
      dragged
  ])
})
